import { render, staticRenderFns } from "./ManageNewsStatusHist.vue?vue&type=template&id=0b3cf2f0"
import script from "./ManageNewsStatusHist.vue?vue&type=script&lang=js"
export * from "./ManageNewsStatusHist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports